<template>
	<div>
		<b-row class="print-row mt-3" v-if="Character.Equipment.Equipped.length > 0">
			<b-col>
				<h4 class="avoid-page-break-after">Equipped Items</h4>
			</b-col>
		</b-row>
		<b-row class="print-row mt-3" v-for="(item, index) in Character.Equipment.Equipped" :key="'details-equipment-equipped-'+index">
			<b-col cols="2">
				<strong>{{item.Name}}</strong>
			</b-col>
			<b-col cols="10" class="pre">
				{{item.Description}}
			</b-col>
		</b-row>
	</div>
</template>

<script>
export default {
	computed: {
		Character: function() {
			return this.$store.state.Character
		},
	}
}
</script>

<style scoped>

</style>